import React, { Component } from "react";
import mainImage from "../../assests/images/12.png";

export default class ExperienceImg extends Component {
  render() {
    return <img src={mainImage} alt="Feeling Proud" />;
  }
}
